import React from 'react';

const Header = ({ activeIndex = 0, onNavigate, onNavigateToAbout }) => {
  const getNavItemClass = (index) => {
    const isActive = activeIndex === index;
    return `transition-colors duration-300 font-header ${
      isActive ? 'text-blue-600 font-bold' : 'text-[#1a1a1a] hover:text-blue-500'
    }`;
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 p-4">
      <div className="max-w-6xl mx-auto flex justify-between items-center p-3 px-6 rounded-xl card-glass-header">
        <button
          onClick={() => onNavigate && onNavigate(0)}
          className="text-xl font-semibold tracking-widest font-header text-left"
          style={{ color: "#1a1a1a" }}
        >
          TOWER-INTEGRATIONS
        </button>
        <nav className="hidden md:flex items-center space-x-6 text-base">
          <button
            onClick={() => onNavigateToAbout && onNavigateToAbout()}
            className={getNavItemClass(1)}
          >
            About
          </button>
          <button
            onClick={() => onNavigate && onNavigate(2)}
            className={getNavItemClass(2)}
          >
            Work
          </button>
          <button
            onClick={() => onNavigate && onNavigate(3)}
            className={getNavItemClass(3)}
          >
            Payment
          </button>
          <button
            onClick={() => onNavigate && onNavigate(4)}
            className={`btn-glass font-semibold px-4 py-2 rounded-lg font-header ${
              activeIndex === 4 ? 'ring-2 ring-blue-500 shadow-lg' : ''
            }`}
          >
            Contact
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;

